import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

export class UserType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'User';

  friendlyName = 'User';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];
  properties = properties;

  get example() {
    return {
      _id: '000000yy1oifVoJgbY8nGc',
    };
  }

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const userTypeDefinition = new UserType();

Types.addBaseType(userTypeDefinition);
export { userTypeDefinition };
